<template lang="pug">
  button.btn(
    :class="btnClass"
    :type="btnType"
    :style="btnStyle"
  )
    span.btn__text.t-ttu.t-tdn {{ btnText }}
</template>

<script>
export default {
  props: {
    btnClass: {
      type: String,
      default: ``
    },
    btnType: {
      type: String,
      default: `button`
    },
    btnText: {
      type: String,
      default: ``
    },
    btnStyle: Object
  }
}
</script>

<style lang="scss">
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: flex-start;
    min-width: 12rem;
    padding: 1.375rem 2rem;
    border-radius: 2rem;
    border: 0;
    background-color: transparent;
    transition: $trs;

    &--fill {
      background-color: currentColor;

      &:hover {
        background-color: $blue;
      }
    }
  }

  .btn__text {
    @include font('m');
    font-size: 0.875rem;
    line-height: 1.2;
    letter-spacing: 0.06em;

    .btn--fill & {
      color: $white;
    }
  }
</style>
